<template>
  <div class="PlatformConnectionsListView">
    <ShPageHeader title="Lista połączeń"
                  :description="`Lista połaczeń wszystkich projektów IVR`"
                  :breadcrumb-items="[
                    { label: 'zarządzanie' },
                    { label: 'lista połączeń', path: '/connections-list' }
                  ]" />
    <ShPageLayout>
      <ConnectionsList :project-list="projectList" />
    </ShPageLayout>
  </div>
</template>

<script>
import ConnectionsList from '@/components/Connections/ConnectionsList';

export default {
  name: 'PlatformConnectionsList',
  components: {
    ConnectionsList,
  },
  beforeRouteLeave(to, from, next) {
    this.$EventBus.$emit('PlatformConnections/TURN_PLAYER_VISIBILITY_OFF');
    next();
  },
  computed: {
    projectList() {
      return this.$store.getters['client/projects/list']?.records;
    },
  },
  async created() {
    await this.$store.dispatch('client/projects/getList');
    this.$store.dispatch('sms/getSmsHeadersList');
  },
};
</script>
